const SKIP_KEY = "arcade-howto-known";
const legacySkipKey = (gameId) => `arcade-howto-known:${gameId}`;

const canUseStorage = () =>
  typeof window !== "undefined" && typeof window.localStorage !== "undefined";

export const shouldSkipHowToPrompt = (gameId) => {
  if (!canUseStorage()) return false;
  try {
    if (window.localStorage.getItem(SKIP_KEY) === "1") return true;
    // Legacy per-game keys from earlier builds.
    if (gameId && window.localStorage.getItem(legacySkipKey(gameId)) === "1") {
      return true;
    }
    return false;
  } catch {
    return false;
  }
};

export const markHowToPromptSeen = () => {
  if (!canUseStorage()) return;
  try {
    window.localStorage.setItem(SKIP_KEY, "1");
  } catch {
    // ignore quota / private mode
  }
};

export const clearHowToPromptSeen = () => {
  if (!canUseStorage()) return;
  try {
    window.localStorage.removeItem(SKIP_KEY);
  } catch {
    // ignore quota / private mode
  }
};
